/** @ignore *//** */
const config = {
  version: '2.14.0',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts